module.exports = __webpack_public_path__ + "dba4f80a211c441d363dc3f36bdc590a.png";